// extracted by mini-css-extract-plugin
export var divider = "_ev-7";
export var itemsToggle = "_ev-8";
export var mergeModal = "_ev-1";
export var optionCard = "_ev-4";
export var radioGroup = "_ev-6";
export var radioOption = "_ev-0";
export var selected = "_ev-5";
export var shipmentOptions = "_ev-2";
export var tableOptions = "_ev-3";